import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { loginWithUserId } from '../services/api';

const Login = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  // ✅ Handle all login scenarios
  function extractParams() {
    const searchParams = new URLSearchParams(location.search);
    let id = searchParams.get('id');
    const redirectTo = searchParams.get('redirectTo') || '/tsd';

    // ✅ If no plain id param, try decrypting from ?data=
    if (!id && searchParams.get('data')) {
      try {
        const decoded = atob(searchParams.get('data')); // e.g. "id=351"
        const tempParams = new URLSearchParams(decoded);
        id = tempParams.get('id');
      } catch (e) {
        console.warn("Failed to decode encrypted data param:", e);
      }
    }

    return { id, redirectTo };
  }

  function isTokenExpired(token) {
    if (!token) return true;
    try {
      const [, payload] = token.split('.');
      const decoded = JSON.parse(atob(payload));
      const now = Math.floor(Date.now() / 1000);
      return decoded.exp < now;
    } catch (e) {
      console.error("Failed to decode token", e);
      return true;
    }
  }

  useEffect(() => {
    const { id, redirectTo } = extractParams();
    const token = localStorage.getItem('token');

    if (token && !isTokenExpired(token)) {
      navigate(redirectTo);
      setLoading(false);
      return;
    }

    if (token && isTokenExpired(token)) {
      localStorage.clear();
      window.location.reload();
      return;
    }

    if (id) {
      loginWithUserId(id)
        .then(res => {
          const token = res.data.token;
          if (isTokenExpired(token)) {
            setError("Received expired token.");
            return;
          }

          const imageUrl = `https://www.trackerteer.com/accountspckg/framework/uploads/images/thumbnails/profile/0/500/${res.data.user.image}`;

          localStorage.setItem('token', token);
          localStorage.setItem('user_id', res.data.user.user_id);
          localStorage.setItem('firstname', res.data.user.firstname);
          localStorage.setItem('lastname', res.data.user.lastname);
          localStorage.setItem('email', res.data.user.email);
          localStorage.setItem('image', imageUrl);

          navigate(redirectTo);
        })
        .catch(err => {
          console.error('Login error', err);
          setError('Login failed. Please check the link or ID.');
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setError('No ID found.');
      setLoading(false);
    }
  }, [location, navigate]);

  if (loading) return <div>Loading...</div>;

  return (
    <div className="container mt-5">
      {error ? (
        <div className="alert alert-danger">{error}</div>
      ) : (
        <div>Logging you in...</div>
      )}
    </div>
  );
};

export default Login;
